import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import RequestUpdateService from './RequestUpdateService';


// Actions
const GET_REQUEST_UPDATE = 'requestUpdate/GET_REQUEST_UPDATE';
const UPDATE_REQUEST = 'requestUpdate/UPDATE_REQUEST';
const CREATE_REQUEST = 'requestUpdate/CREATE_REQUEST';

const initialState = {
  currentRequest: {},
};

// Reducer
export default function requestUpdateReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_REQUEST_UPDATE:
      return {
        ...state,
        currentRequest: action.result.data || {},
      };
    case UPDATE_REQUEST:
      return {
        ...state,
        errorUpdateRequest: !!action.result.error,
      };
    default:
      return state;
  }
}

// Action Creators
export function getRequestUpdateAction(result) {
  return { type: GET_REQUEST_UPDATE, result };
}

export function updateRequestAction(result) {
  return { type: UPDATE_REQUEST, result };
}

export function createRequestAction(result) {
  return { type: CREATE_REQUEST, result };
}

// Action dispatcher functions

export function getRequestUpdate(tcId, testingEventId) {
  return createDispatchFunction(
    partial(RequestUpdateService.getRequestUpdate, tcId, testingEventId),
    getRequestUpdateAction
  );
}

export function updateRequest(data) {
  return createDispatchFunction(
    partial(RequestUpdateService.updateRequest, data),
    updateRequestAction
  );
}

export function createRequest(data) {
  return createDispatchFunction(
    partial(RequestUpdateService.createRequest, data),
    createRequestAction
  );
}